import { render } from "./ProductStock.vue?vue&type=template&id=7bce25aa"
import script from "./ProductStock.vue?vue&type=script&lang=js"
export * from "./ProductStock.vue?vue&type=script&lang=js"
script.render = render

export default script